import React from 'react';
import { Helmet } from 'react-helmet';
import BatchSchedulesList from 'src/component/UI/BatchSchedulesList';
import { isWhitelabel } from 'src/utils/utils';
import { useTranslation } from 'src/i18n';

export default function BatchSchedulesScreen () {
  const { t } = useTranslation();
  const title = isWhitelabel() ? 'ATCOM' : 'SmartTrace';

  return (
    <div className='page' data-testid='batch-schedules-screen'>
      <Helmet>
        <title>{title} - {t('batchSchedules.batchSchedules')}</title>
      </Helmet>
      <BatchSchedulesList/>
    </div>
  );
}
